"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//import nestedComponentForm from '../_classes/nested/NestedComponent.form';
const AriForm_1 = require("../../../AriForm");
const Components_1 = __importDefault(require("../../Components"));
const richeditor_edit_display_1 = __importDefault(require("./editForm/richeditor.edit.display"));
/**
 *
 * @param {...any} extend
 */
function default_1(...extend) {
    return Components_1.default.baseEditForm([
        {
            key: 'display',
            components: [
                ...richeditor_edit_display_1.default,
                {
                    key: 'modalEdit',
                    ignore: AriForm_1.AriForm.isBPM,
                },
                {
                    key: 'description',
                    ignore: AriForm_1.AriForm.isBPM,
                },
                {
                    key: 'tabindex',
                    ignore: AriForm_1.AriForm.isBPM,
                },
            ]
        },
        {
            key: 'data',
            ignore: AriForm_1.AriForm.isBPM
        },
        {
            key: 'validation',
            components: [
                {
                    key: 'validateOn',
                    ignore: AriForm_1.AriForm.isBPM
                },
                {
                    key: 'json-validation-json',
                    ignore: AriForm_1.AriForm.isBPM
                },
                {
                    key: 'errors',
                    ignore: AriForm_1.AriForm.isBPM
                },
                {
                    key: 'custom-validation-js',
                    ignore: AriForm_1.AriForm.isBPM
                },
                {
                    key: 'validate.customMessage',
                    ignore: AriForm_1.AriForm.isBPM
                },
                {
                    key: 'errorLabel',
                    ignore: AriForm_1.AriForm.isBPM
                },
            ]
        },
        {
            key: 'api',
            components: [
                {
                    key: 'tags',
                    ignore: AriForm_1.AriForm.isBPM
                },
                {
                    key: 'properties',
                    ignore: AriForm_1.AriForm.isBPM
                }
            ]
        },
        {
            key: 'logic',
            ignore: AriForm_1.AriForm.isBPM,
        },
        {
            key: 'layout',
            ignore: AriForm_1.AriForm.isBPM,
        },
        {
            key: 'addons',
            ignore: AriForm_1.AriForm.isBPM,
        },
        {
            key: 'conditional',
            ignore: AriForm_1.AriForm.isBPM,
        },
        {
            key: 'autofocus',
            ignore: AriForm_1.AriForm.isBPM,
        },
    ], ...extend);
}
exports.default = default_1;
